<template>
  <div class="springClass">
    <headers ref="header" style="position:fixed;width: 100%;z-index:99" :isChange="true" />
    <div class="springNav">
      <div class="theleft" @click="nav()"></div>
      <el-dialog title="扫描咨询" :visible.sync="centerDialogVisible" width="30%" center>
          <img src="../../assets/bottom/erCode2.jpg" style="width: 180px;"/>
          <img src="../../assets/bottom/erCode1.jpg" style="width: 180px;"/>
          <span slot="footer" class="dialog-footer">
            <el-button type="primary" @click="centerDialogVisible = false">确 定</el-button>
          </span>
        </el-dialog>
      <div class="theright" @click="centerDialogVisible = true">
      </div>
    </div>
    <!-- tab选项 -->
    <div class="switchTab">
      <ul>
        <li v-for="(ele,index) in switchTab" :key="index" @click="switchTabs(ele.type)"
          :class="n == ele.type ? 'active':''"><a :href="ele.theurlId">{{ele.tit}}</a></li>
      </ul>
    </div>
    <!-- 适用学员 -->
    <div id="thestudent" name="thestudent" class="student">
      <h1>适用学员</h1>
      <div class="studentCard">
        <div class="studentCardCon" v-for="(item,indexs) in studentCard" :key="indexs">
          <img :src="item.icons">
          <h2>{{item.name}}</h2>
          <p class="cardmarginP">{{item.studentStatus1}}</p>
          <p>{{item.studentStatus2}}</p>
        </div>
      </div>
    </div>
    <!-- 课程简介 -->
    <div class="courseBrief" name="courseBrief" id='courseBrief'>
      <h1>课程简介</h1>
      <div class="courseCon" v-html="introductInfo" id="introduce"></div>
      <div class="newFuck">
        <div class="left">
          <img src="../../assets/sprintClass/new/bg6.png" alt="">
          <div class="text">
            <p>没有知识体系前</p>
            <p>一切都是碎片化的 </p>
          </div>
        </div>
        <div class="center">
          <span><img src="../../assets/sprintClass/new/94a9b529a91162f3ded13c09e1181c0.png" alt=""></span><span></span>
          <span><img src="../../assets/sprintClass/new/06d7a034aa5970d9d1afce8341c588e.png" alt=""></span>
        </div>
        <div class="right">
          <div class="text">
            <p>有了知识体系后</p>
            <p>一切都是系统化的 </p>
          </div>
          <img src="../../assets/sprintClass/new/bg7.png" alt="">
        </div>
      </div>
    </div>
    <!-- 课程优势 -->
    <div class="courseAdvantage" id="fuck_fuck">
      <div class="newFuck_shit">
        <div class="newShit">
          <h1>课程优势</h1>
          <p><span>01.</span></p>
          <div class="swiper">
            <el-carousel arrow="never" height="550px" indicator-position="none" :autoplay="false">
              <el-carousel-item v-for="item in 4" :key="item">
                <div class="teacher">
                  <div class="left" style="position:relative;height:550px;width:400px;">
                    <img :src="imgs[i].img" alt="" style="position:absolute;right: 0;bottom:0;">
                  </div>
                  <div class="right">
                    <p>顶级名师授课</p>
                    <p>{{teacherTeams[i].position}}</p>
                    <p>{{teacherTeams[i].nick}}</p>
                    <p>{{teacherTeams[i].profile}}</p>
                    <div class="shit_fuck">
                      <swiper :options="teacherImg2" :not-next-tick="notNextTick" ref="wocaorile" style="width: 519px;"
                        @slideChange="slideChange" class="swiper-no-swiping">
                        <!-- slides -->
                        <swiper-slide class="swiperText" v-for="(item,index) in imgs" :key="index">
                          <img :src="item.url" alt="" style="width: 80px;height: 80px;" @click="act(index)">
                        </swiper-slide>
                        <!-- Optional controls -->
                        <div class="swiper-button-prev" slot="button-prev" style="margin-left: 0;" @click="prev()">
                        </div>
                        <div class="swiper-button-next" slot="button-next" style="left: 1120px;" @click="next()"></div>
                      </swiper>
                    </div>
                  </div>
                </div>
              </el-carousel-item>
            </el-carousel>
          </div>
        </div>
      </div>
      <div class="advantageCard advantageTexts arrange ">
        <p class="advantCardText advantageCardTits">02.</p>
        <p class="cardTitles">科学的课程安排</p>
        <div class="fuck_items">
          <div class="fuck_item">
            <p><img src="../../assets/sprintClass/new/icon6.png" alt=""></p>
            <p><span>1</span></p>
            <p>
            <p>通过海量高频真题</p>
            <p>帮助学员举一反三</p>
            </p>
            <p>不同于其他机构的一刀切，我们会根据各个章节的考查频次和中国学生的准确率特点，进行更符合中国学生实际的科学安排。</p>
          </div>
          <div class="fuck_item">
            <p><img src="../../assets/sprintClass/new/icon7.png" alt=""></p>
            <p><span>2</span></p>
            <p>
            <p>系统化覆盖100%考点</p>
            <p>不打“5天/7天速成”的浮夸标签</p>
            </p>
            <p>我们拒绝标题党，不打“5天/7天速成”的浮夸标签。全程班每个科目均为期14天，系统化覆盖GMAT的全部考点，为学员详细梳理各个考点的真正考查形式&套路满满的解题思路，指导学员如何快速解题、避开tricky
              traps。</p>
          </div>
          <div class="fuck_item">
            <p><img src="../../assets/sprintClass/new/icon8.png" alt=""></p>
            <p><span>3</span></p>
            <p>
            <p>课程知识体系安排合理</p>
            <p>符合中国学生特点</p>
            </p>
            <p>“拥有市面最全真题题库”的老师们对GMAT题库的熟悉度处于行业顶尖水平，精心挑选最具有代表性的真题，将真题与知识点、做题方法紧密结合，通过每天的作业任务和讲解，帮助大家切实巩固和消化知识点。</p>
          </div>
        </div>
      </div>
      <p class="advantCardText advantageCardTits">03.</p>
      <p class="cardTitles fuck">一站式全包服务</p>
      <div class="change">
        <!--  服务第一点 -->
        <div class="advantageCard">
          <div>
            <div class="teacherText">
              <ul>
                <li>主讲老师360天在线一对一答疑</li>
                <li>
                  <p>老师们不仅在课程期间悉心教学，在课后也会继续提供长达一年的分析esr、免费答疑、备考规划等高质量服务。</p>
                  <p>与很多机构的助教答疑不同，助教缺乏教学经验，并不能准确识别同学们的薄弱点并且提供有效的解答。我们一直坚持主讲老师亲自答疑，答疑期是一年，直至同学们顺利出分！</p>
                </li>
              </ul>
            </div>
          </div>
          <!--  服务swiper1 -->
          <div class="server">
            <el-carousel :interval="5000" arrow="always" style="height:400px;width: 60%;margin: 50px auto 0 auto ;"
              indicator-position='none'>
              <el-carousel-item v-for="(item,index) in thelistt" :key="index" style="height:400px;text-align: center;">
                <img :src="base + item.imgSrc" style="width: 100%;margin: 0 auto;">
              </el-carousel-item>
            </el-carousel>
          </div>
        </div>
        <!--  服务第二点 -->
        <div class="advantageCard rowReverse">
          <div>
            <div class="teacherText">
              <ul>
                <li>督导老师全程规划</li>
                <li>全程班贴心配备GMAT高分前学员作为mentor督导老师，全程陪伴同学们的每日学习，专治拖延症！并且提供心理疏导和曾经的备考经验。</li>
              </ul>
            </div>
          </div>
          <!--  服务swiper1 -->
          <div class="server">
            <el-carousel :interval="5000" arrow="always" style="height:400px;width: 60%;margin: 50px auto 0 auto ;"
              indicator-position='none'>
              <el-carousel-item v-for="(item,index) in thelistimg" :key="index"
                style="height:400px;text-align: center;">
                <img :src="base+item.imgSrc" style="width: 100%;margin: 0 auto;">
              </el-carousel-item>
            </el-carousel>
          </div>
        </div>
      </div>

      <!--  真题资料 -->
      <div class="fuck_fuck">
        <div class="fuck_shit">
          <p class="tit">04.</p>
          <div class="fuckCard">
            <div class="fuck_left">
              <div>独家最新真题资料</div>
              <div>
                <p>“独家结课礼包+全网最强机经</p>
                <p>“为你甄选满足实战需求的大量GMAT真题。</p>
              </div>
              <div class="fuck_more">
                <div><img src="../../assets/sprintClass/new/8fe5e9f45fb56a5492b79a8d5293d88.png" alt=""
                    class="fuck_img1"></div>
                <div>
                  <p>1. 别家机构有的资料我们都有</p>
                  <p>常规的资料：OG/PREP/GWD/OG分册/Advanced 300题，我们统统都有。</p>
                </div>
                <div><img src="../../assets/sprintClass/new/8fe5e9f45fb56a5492b79a8d5293d88.png" alt=""
                    class="fuck_img2"></div>
              </div>
              <div class="fuck_line"></div>
              <div><img src="../../assets/sprintClass/new/8fe5e9f45fb56a5492b79a8d5293d88.png" alt=""><span>2.
                  别家机构没有的资料我们还有</span></div>
              <div>经常有同学抱怨：怎么在考试时，觉得题目的难度跟OG、PREP、GWD这些题目不太一样呢？Emmm……因为就是不一样啊！</div>
              <div>
                <span>“拥有市面最全真题题库”，老师们会为大家提供市面上没有的独家最新真题，帮助学员真正地模拟考试真实难度（杀G工厂的独家真题资料素来好评无数，甚至很多没时间报班的学员也曾经慕名前来，想要单独购买真题礼包）。</span><img
                  src="../../assets/sprintClass/new/8fe5e9f45fb56a5492b79a8d5293d88.png" alt="">
              </div>
            </div>
            <div class="fuck_right">
              <div>
                <p>GMAT数学全程班</p>
                <p>可额外获得的结课大礼包</p>
              </div>
              <div class="shit_line"></div>
              <div>
                <el-carousel arrow="always" :autoplay="false">
                  <el-carousel-item v-for="item in 4" :key="item">
                    <div
                      style="width: 259px;margin: 0 auto;font-size: 14px;font-family: Source Han Sans SC;font-weight: 400;line-height: 20px;color: #525252;opacity: 1;">
                      <p><span>1：《GMAT数学官方真题完整题库》</span><span>（包括OG、PREP、GWD、300难题）</span></p>
                      <p style="margin-top: 30px;">2：独家真题资料1：《姜姜GMAT数学27套真题》</p>
                      <p style="margin-top: 30px;">3：独家真题资料2：《2020年最新机经真题合集》</p>
                    </div>
                  </el-carousel-item>
                </el-carousel>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- 海量题库swiper -->
      <p class="advantCardText advantageCardTits">05.</p>
      <p class="cardTitles" style="margin-bottom: 105px;">“海量题库搜题做题系统+课后主讲老师逐题真人视频带练”</p>
      <div class="new_shit">
        <div class="shit_left">
          <p>在课程结束后，我们为学员提供免费提供“刷题”服务，每天布置作业任务、并对题目进行讲解，继续监督学习，帮助学员更好地出分。</p>
          <p>复习过程中，学员可同步使用题库系统进行做题、搜题，题库内置海量题目，重点题型全部配备详细的视频/音频讲解！</p>
        </div>
        <div class="shit_right">
          <el-carousel arrow="always" style="width: 550px;" height="280px" :autoplay="false">
            <el-carousel-item v-for="(item,index) in thevidee" :key="index">
              <div style="width: 442px;height: 251px;margin: 0 auto;opacity: 1;border-radius: 8px;">
                <video style="width: 100%;height: 100%;" :src="base+item.videSrc" controls="controls"
                  class="av"></video>
              </div>
            </el-carousel-item>
          </el-carousel>
        </div>
      </div>
    </div>
    <!-- 出分效果 -->
    <div class="scoringeFfect" id="scoringeFfect">
      <p style="color: #FFFFFF;text-align: center;position:relative;top: 40px;font-size:16px;font-weight:700;">出分效果</p>
      <div class="swiperCon">
        <swiper style="margin-top:40px;" :options="teacherImg1" :not-next-tick="notNextTick" ref="mySwiper">
          <!-- slides -->
          <swiper-slide id="zheswiper" class="swiperText" v-for="(ele,index) in givePoints" :key='index'>
            <img :src="base + ele" :key='index'>
            <!-- {{givePoints.length}} -->
          </swiper-slide>
          <!-- Optional controls -->
          <div id="swiper-button_thesp" class="swiper-button-prev swiperLeftBtn" slot="button-prev"></div>
          <div class="swiper-button-next" slot="button-next"></div>
        </swiper>
      </div>
    </div>
    <!--  安排与常见问题 -->
    <div class="courseArrange" id="courseArrange">
      <!-- 课程安排 -->
      <!-- <div class="arrange">
        <h1>课程安排</h1>
        <div class="arrangeTab">
          <ul>
            <li v-for="(arrange,indexange) in arrangeTab" :key="indexange" :class="arrangeN == indexange ? 'arrangeActive':''"
              @click="switchArrange(indexange,arrange.data)">
              {{arrange.name}}
            </li>
          </ul>
        </div>
        <div class="arrangeCon">
          <el-table :data="tableData" style="width: 100%" :row-class-name="tableRowClassName">
            <el-table-column prop="date" label="日期" width="273">
            </el-table-column>
            <el-table-column label="上课形式" width="273">
              <template slot-scope="scope">
                <el-button size="mini" :class="scope.row.channel == '录播' ? 'tabButton':'tabButtonOther'">{{scope.row.channel}}</el-button>
              </template>
            </el-table-column>
            <el-table-column  label="上课内容" :show-overflow-tooltip="true"  prop="description">
            </el-table-column>
          </el-table>
        </div>
      </div> -->
      <!-- 常见问题 -->
      <div class="commonProblem">
        <h1>常见问题</h1>
        <div class="matterBox">
          <!-- <div class="leftBox">
            <div class="leftBoxTit">Questions</div> -->
          <!-- <div v-for="(matter,indexter) in matterTab" :key="indexter" @click="switchMatter(indexter,matter.list)"  :class="matters == indexter ? 'matterActive':'' "><a href="">{{matter.type}}</a></div> -->
          <!-- <div >
              <ul>
                <li>如何购买课程?</li>
                <li>上课所需设备?</li>
                <li>课程有效期是多久?</li>
                <li>老师在哪里答疑?</li>
                <li>其它问题?</li>
              </ul>
            </div>
          </div> -->
          <div class="rightBox">
            <div class="d_jump">
              <span><b>1、如何购买课程?</b>本网站所有课程授课均在cctalk第三方平台完成，课程质量、后续服务以及资金安全，均由第三方监督保障。如欲报名课程，请详询小助手，<br><span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;获取更多课程详细信息及优惠信息等。</span></span>
            </div>
            <div>
              <span><b>2、上课所需设备?</b>电脑端、手机端、Pad端任意一端均可兼容。</span>
            </div>
            <div>
              <span><b>3、课程有效期是多久?</b>自开课日起360天内有效，支持直播、录播360天回放，支持多平台回放。</span>
            </div>
            <div>
              <span><b>4、老师在哪里答疑?</b>所有科目的答疑由主讲老师亲自负责，学员即可以选择在班级群内@老师，也可以添加老师微信，私信老师进行一对一答疑。</span>
            </div>
            <div>
              <span><b>5、其它问题?</b>扫码咨询小助手，我们尽全力解答您的问题。</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  </div>
</template>

<script>
  import home from "@/api/home.js";
  import api from "@/api/sprintClass.js";
  import baseUrl from "@/api/common.js";
  import headers from "../../components/header.vue";
  import $ from "jquery";



  export default {
    components: {
      headers,
    },
    data() {
      return {
        centerDialogVisible: false,
        thelistt: [{
            id: "1",
            imgSrc: "/static/img/dayi11.jpg"
          },
          {
            id: "2",
            imgSrc: "/static/img/dayi22.jpg"
          },
          {
            id: "3",
            imgSrc: "/static/img/dayi33.jpg"
          },
          {
            id: "4",
            imgSrc: "/static/img/dayi44.jpg"
          },
          {
            id: "5",
            imgSrc: "/static/img/dayi55.jpg"
          },
        ],
        thelistimg: [{
            id: "1",
            imgSrc: "/static/img/jiandu11.jpg"
          },
          {
            id: "2",
            imgSrc: "/static/img/jiandu22.jpg"
          },
          {
            id: "3",
            imgSrc: "/static/img/jiandu33.jpg"
          },
          {
            id: "4",
            imgSrc: "/static/img/jiandu44.jpg"
          },
          {
            id: "5",
            imgSrc: "/static/img/jiandu55.jpg"
          },
        ],
        thevidee: [{
            id: "1",
            videSrc: "/static/video/zhuyi.mp4"
          },
          {
            id: "2",
            videSrc: "/static/video/zhuer.mp4"
          },
        ],
        // edit: false,
        i: 0,
        imgs: [{
            url: require("../../assets/teachers/img5.png"),
            img: require("../../assets/teachers/img7.png"),
          },
          {
            url: require("../../assets/teachers/img3.png"),
            img: require("../../assets/teachers/img9.png"),
          },
          {
            url: require("../../assets/teachers/img1.png"),
            img: require("../../assets/teachers/img12.png"),
          },
          {
            url: require("../../assets/teachers/img4.png"),
            img: require("../../assets/teachers/img8.png"),
          },
          {
            url: require("../../assets/teachers/img2.png"),
            img: require("../../assets/teachers/img11.png"),
          },
          {
            url: require("../../assets/teachers/img6.png"),
            img: require("../../assets/teachers/img13.png"),
          },
        ],
        options: [{
            value: "选项1",
            label: "黄金糕",
          },
          {
            value: "选项2",
            label: "双皮奶",
          },
        ],
        value: "",
        navCodes: require("@/assets/login/navCode.png"),
        herderTits: {
          color: "#666666",
        },
        headerBack: {
          background: "#ffffff"
        },
        headerIcon: require("@/assets/home/headerNav.png"),
        n: 1,
        switchTab: [{
            tit: "适用学员",
            type: 1,
            theurlId: "#thestudent"
          },
          {
            tit: "课程简介",
            type: 2,
            theurlId: "#courseBrief"
          },
          {
            tit: "课程优势",
            type: 3,
            theurlId: "#fuck_fuck"
          },
          {
            tit: "出分效果",
            type: 4,
            theurlId: "#scoringeFfect"
          },
          {
            tit: "常见问题",
            type: 5,
            theurlId: "#courseArrange"
          },
        ],
        base: baseUrl,
        //适用学员
        studentCard: [{
            icons: require("@/assets/sprintClass/new/icon1.png"),
            name: "小白同学",
            studentStatus1: "刚接触GMAT",
            studentStatus2: "没有任何头绪",
          },
          {
            icons: require("@/assets/sprintClass/new/icon2.png"),
            name: "遇到瓶颈期",
            studentStatus1: "刷了很多题目",
            studentStatus2: "自学遇到了严重瓶颈期的同学",
          },
          {
            icons: require("@/assets/sprintClass/new/icon3.png"),
            name: "冲刺高分",
            studentStatus1: "有一定基础",
            studentStatus2: "想进一步冲击高分的同学",
          },
          {
            icons: require("@/assets/sprintClass/new/icon4.png"),
            name: "快速出分",
            studentStatus1: "短期冲刺",
            studentStatus2: "想快速出分的同学",
          },
          {
            icons: require("@/assets/sprintClass/new/icon5.png"),
            name: "课程效果不明显",
            studentStatus1: "上过其他课程",
            studentStatus2: "但是效果不显著的同学",
          },
        ],
        arrangeN: 0,
        //课程安排 Tab
        arrangeTab: [],
        //课程安排 table
        tableData: [],
        matters: 0,
        //常见问题tab
        matterTab: [],
        probleList: [],
        notNextTick: true,
        //swiper
        teacherImg: {
          autoplay: false,
          grabCursor: true,
          setWrapperSize: true,
          autoHeight: true,
          paginationClickable: true,
          prevButton: ".swiper-button-prev",
          nextButton: ".swiper-button-next",
          mousewheelControl: false,
          observeParents: true,
          debugger: true,
          slidesPerView: 1,
        },
        teacherImg1: {
          autoplay: true,
          loop: true,
          speed: 2500,
          grabCursor: true,
          setWrapperSize: true,
          autoHeight: true,
          paginationClickable: true,
          prevButton: ".swiper-button-prev",
          nextButton: ".swiper-button-next",
          mousewheelControl: false,
          observeParents: true,
          debugger: true,
          slidesPerView: 3,
        },
        canTouch: true,
        teacherTeams: [{
          position: null
        }],
        teacherImg2: {
          loop: true,
          autoplay: false,
          grabCursor: true,
          setWrapperSize: true,
          autoHeight: true,
          paginationClickable: true,
          prevButton: ".swiper-button-prev",
          nextButton: ".swiper-button-next",
          mousewheelControl: false,
          observeParents: true,
          debugger: true,
          slidesPerView: 5,
        },
        //课程优势  老师
        techerAdvantage: [],
        //课程简介
        introductInfo: "",
        //出分效果
        givePoints: [],
        navInfo: {},
      };
    },
    mounted() {
      this.getTeacherList();
      window.addEventListener("scroll", this.handleScrollx);
      // this.$refs.header.headerBack = {
      //   backgroundColor:'#fff'
      // }
      // this.$refs.header.herderTits = {
      //       color:'rgb(102,102,102)'
      //     }
      // this.$refs.header.headerIcon = require('@/assets/home/headerNav.png')
      // this.problems();
      // this.advantage();
      this.courseIntroductInfo();
      this.arrangeList();
      this.effectClass();
      this.getNav();
    },
    updated() {
      let $introduce_span = $("#introduce>p>span");
      console.log($introduce_span);
      $introduce_span.css({
        lineHeight: "25px",
        fontSize: "13px",
        color: "#666666",
        width: "1000px",
        display: "inline-block",
      });
    },
    beforeDestroy() {
      // console.log('销毁');
      window.removeEventListener("scroll", this.handleScrollx);
    },
    methods: {
      getTeacherList() {
        let params = {
          type: "home",
        };
        let query = this.$qs.stringify(params);
        home
          .getTeacher(query)
          .then((res) => {
            this.teacherTeams = res.data.data;
            // console.log(this.teacherTeams);
          })
          .catch((err) => {
            this.$message.error("错误");
          });
      },
      act(i) {
        console.log(i);
      },
      slideChange() {},
      prev() {
        if (this.$refs.wocaorile[0].swiper.realIndex > 0) {
          this.i = this.$refs.wocaorile[0].swiper.realIndex - 1;
          console.log(this.i);
        } else {
          this.i = 5;
        }
      },
      next() {
        if (this.$refs.wocaorile[0].swiper.realIndex < 5) {
          this.i = this.$refs.wocaorile[0].swiper.realIndex + 1;
          console.log(this.i);
        } else {
          this.i = 0;
        }
      },

      handleScrollx() {
        let header = this.$refs.header;
        let scrollTop =
          document.body.scrollTop || document.documentElement.scrollTop;
        if (scrollTop == 0) {
          header.headerBack.background = "";
          header.herderTits.color = "hsla(0,0%,100%,.8)";
          header.headerIcon = require("@/assets/bottom/bottomIcon.png");
          header.loginButton = {
            backgroundColor: "white",
            color: " rgba(0,0,0,.8)",
          };
          header.isTop = true;

          header.phoneButton = {
            background: "hsla(0,0%,100%,.08)",
            border: "1px solid hsla(0,0%,100%,.8)",
          };
          // this.navCodes = require('@/assets/login/whiteCode.png');
        } else {
          header.isTop = false;
          header.headerBack.background = "#ffffff";
          header.herderTits.color = "#666666";
          header.headerIcon = require("@/assets/home/headerNav.png");
          header.loginButton = {
            background: "#618aff",
            color: "#fff",
          };
          header.phoneButton = {
            color: "#618aff",
            border: "1px solid #618aff",
          };
          // this.navCodes = require('@/assets/login/navCode.png');
        }
        if (scrollTop > 723) {
          this.rightDiv = true;
        } else {
          this.rightDiv = false;
        }
      },
      switchTabs(type) {
        // console.log(type)
        this.n = type;
      },
      switchArrange(type, data) {
        this.arrangeN = type;
        this.tableData = data;
      },
      tableRowClassName({
        row,
        rowIndex
      }) {
        if (row.channel == "录播") {
          return "warning-row ";
        } else {
          return "success-row";
        }
        return "";
      },
      nav() {
        this.$router.push("/excellentcourse");
      },
      nav2() {
        // this.$router.push("/excellentcourse");
      },
      //导航内容
      getNav() {
        let params = {
          type: "sprint",
        };
        let query = this.$qs.stringify(params);
        api.getNavInfo(query).then((res) => {
          if (res.data.code == 0) {
            this.navInfo = res.data.data;
            console.log(this.navInfo);
          }
        });
      },
      //常见问题tab切换
      switchMatter(type, list) {
        this.matters = type;
        this.probleList = list;
      },
      //课程优势
      // advantage() {
      //   let paramas = {
      //     type: "sprint",
      //   };
      //   let query = this.$qs.stringify(paramas);
      //   api
      //     .classAdvantage(query)
      //     .then((res) => {
      //       this.techerAdvantage = res.data.data;
      //       // console.log(res.data.data)
      //     })
      //     .catch((err) => {
      //       console.log(err);
      //     });
      // },
      //课程简介
      courseIntroductInfo() {
        let params = {
          type: "sprint",
        };
        let query = this.$qs.stringify(params);
        api
          .courseIntroducte(query)
          .then((res) => {
            this.introductInfo = res.data.data.content;
            // console.log(this.introductInfo);
          })
          .catch((err) => {
            this.$message.error("获取课程简介失败");
          });
      },
      //常见问题
      // problems() {
      //   let paramas = {
      //     type: 1,
      //   };
      //   let query = this.$qs.stringify(paramas);
      //   api
      //     .commonProblem(query)
      //     .then((res) => {
      //       this.matterTab = res.data.data;
      //     })
      //     .catch((err) => {
      //       console.log(err);
      //     });
      // },
      //课程安排
      arrangeList() {
        let paramas = {
          type: "sprint",
        };
        let query = this.$qs.stringify(paramas);
        api
          .arrangeClass(query)
          .then((res) => {
            this.arrangeTab = res.data.data;
          })
          .catch((err) => {
            this.$message.error("课程安排获取失败");
          });
      },
      //出分效果
      effectClass() {
        let paramas = {
          type: "sprint",
        };
        let query = this.$qs.stringify(paramas);
        api
          .studyEffect(query)
          .then((res) => {
            this.givePoints = res.data.data;
            // console.log(this.givePoints);
          })
          .catch((err) => {
            this.$message.error("出分效果获取失败");
          });
      },
    },
    computed: {
      swiper() {
        return this.$refs.mySwiper.swiper;
      },
    },
  };
</script>

<style scoped>
  @import url("../../assets/css/sprintClass.css");
</style>



// WEBPACK FOOTER //
// src/view/excellentCourse/sprintClass.vue